import React from 'react';
import tinyColor from 'tinycolor2';
import classNames from 'classnames';

const Tags = ({ attachmentTags = [], tags = [], stacked = false }) => {
  return (
    <div className={classNames('tag-group-wrapper', { stacked })}>
      <div className="tag-group">
        {attachmentTags.map(tagId => {
          const tag = tags.find(t => t.id === tagId);

          if (!tag) {
            return null;
          }

          const label = tag.label || '';
          const bg = tag.color || '#ccc';
          const fg = tinyColor(bg).isDark() ? '#fff' : '#000';
          return (
            <div className="tag-item" key={tag.id} title={label} style={{ backgroundColor: bg, color: fg }}>
              {label.toUpperCase().charAt(0)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tags;
